import { registerAudienceMessages } from '../i18n'

import { registerDashboardWidget } from '@/features/dashboards'
import { registerReportMessages } from '@/features/reports'
import { DEFAULT_LOCALE, SUPPORTED_LOCALES, i18n, type SupportedLocale } from '@/shared/i18n'

function activeLocale(): SupportedLocale {
  const locale = i18n.global.locale.value
  return (SUPPORTED_LOCALES as readonly string[]).includes(locale)
    ? (locale as SupportedLocale)
    : DEFAULT_LOCALE
}

export function registerAudienceWidgets(): void {
  registerDashboardWidget('funnel', async () => {
    const locale = activeLocale()
    const [component] = await Promise.all([
      import('../components/pages/FunnelExplorationPage.vue'),
      registerReportMessages(locale),
      registerAudienceMessages(locale),
    ])
    return component
  })
}
